import { Controller } from "@hotwired/stimulus"

/**
 * A simple modal controller using native <dialog> element
 *
 * The native dialog element handles:
 * - Modal visibility with showModal()
 * - Backdrop (::backdrop)
 * - ESC key to close (via cancel event)
 * - Focus trap
 * - Scroll lock
 * - Focus restoration
 */
export default class extends Controller {
  static targets = ["dialog"]
  static values = { openOnConnect: Boolean }

  connect() {
    if (this.openOnConnectValue) this.open()
  }

  open() {
    this.dialogTarget.showModal()
    this.startVideos()
  }

  close() {
    this.dialogTarget.close()
  }

  clickOutside(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  stopVideos() {
    this.dialogTarget.querySelectorAll("video").forEach(video => {
      video.pause()
      video.currentTime = 0
    })
  }

  startVideos() {
    this.dialogTarget.querySelectorAll("video").forEach(video => {
      video.play().catch(() => {})
    })
  }
}
